import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {AUTH_TOKEN} from "../../constants/AuthConstant";
import Cookies from "js-cookie";
import shiftJadwalService from "../../services/shiftJadwalService";

export const initialState = {
    loading_shift_jadwal: false,
    data_shift_jadwal: [],
    data_import: [],
    showMessage:false,
    message:'',
}


export const getDataShiftJadwal = createAsyncThunk('shift_jadwal/data',async (data, { rejectWithValue }) => {
    try {
        const response = await shiftJadwalService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getaDataImport = createAsyncThunk('shift_jadwal/dataimport',async (data, { rejectWithValue }) => {
    try {
        const response = await shiftJadwalService.data_import(Cookies.get(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const emptyDataImport = createAsyncThunk('shift_jadwal/emptyimport',async (data, { rejectWithValue }) => {
    try {
        const response = await shiftJadwalService.empty_import(Cookies.get(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const saveDataImport = createAsyncThunk('shift_jadwal/saveimport',async (data, { rejectWithValue }) => {
    try {
        const response = await shiftJadwalService.save_import(Cookies.get(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})


export const shiftJadwalSlice = createSlice({
    name: 'shift_jadwal',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_shift = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataShiftJadwal.fulfilled, (state, action) => {
                state.loading_shift_jadwal = false
                state.data_shift_jadwal = action.payload??[]
            })
            .addCase(getDataShiftJadwal.pending, (state) => {
                state.loading_shift_jadwal = true
            })
            .addCase(getDataShiftJadwal.rejected, (state, action) => {
                state.loading_shift_jadwal = false
                state.data_shift_jadwal = action.payload??[]
            })
            .addCase(getaDataImport.fulfilled, (state, action) => {
                state.loading_shift = false
                state.data_import = action.payload??[]
            })
            .addCase(getaDataImport.pending, (state) => {
                state.loading_shift = true
            })
            .addCase(getaDataImport.rejected, (state, action) => {
                state.loading_shift = false
                state.data_import = action.payload??[]
            })

    },
})

export const {
    showLoading,
} = shiftJadwalSlice.actions

export default shiftJadwalSlice.reducer
